module.exports = __webpack_public_path__ + "fi-battre-val-1e81b6b93915f59f30f098eb8a77fa28.png";


//////////////////
// WEBPACK FOOTER
// ./Resources/public/static-src/images/product-labels/fi-battre-val.png
// module id = 80
// module chunks = 0